// extracted by mini-css-extract-plugin
module.exports = {"animatedButton":"AnimatedButton_animatedButton__17jzF","dance":"AnimatedButton_dance__3wA4q"};